import isObject from 'lodash/isObject';

interface Error<E> {
  errors?: E;
  [k: string]: any;
}

function cleanErrors<
  U extends Record<string, any> = {},
  E extends Record<string, any> = {},
>(update: U, error?: E): E | undefined {
  if (!error || !update) return error;

  return Object.entries(update).reduce((acc, [key, value]) => {
    const errorValue = error[key];
    if (!error) return acc;
    return {
      ...acc,
      [key]: isObject(value) ? cleanErrors(value, errorValue) : undefined,
    };
  }, error);
}

/**
 * Clears any value in error.errors that is defined in update, recursively.
 * E.g.:
 * ```
 * clearError({ foo: 1 }, { errors: { foo: 'error', bar: { baz: 'error' } } });
 * > { errors: { bar: { baz: 'error' } } }
 * ```
 *
 * @param update any object
 * @param error object with same structure as update
 */
export default function cleanError<
  U extends Record<string, any> = {},
  E extends Record<string, any> = {},
>(update: U, error?: Error<E>) {
  return error && { ...error, errors: cleanErrors(update, error.errors) };
}
